<img
  [src]="imageURL"
  [attr.width]="imageWidth"
  [ngClass]="{ 'visibility-hidden': imageHidden }"
/>
